import { jsx as o } from "react/jsx-runtime";
import { getPaymentMethodIcon as r } from "@systemeio/ui/icons";
const a = ({ paymentMethod: e }) => /* @__PURE__ */ o("div", { className: "[&>svg]:fill-THEME-primary/70", children: r(e, { className: "w-5 h-5" }) });
export {
  a as PaymentMethodIcon
};
